import React, { useMemo } from "react";
import { Control, useFormState, useWatch } from "react-hook-form";
import { BranchValues } from "utils/helper/types";

type UseBranchFormProps = {
  control: Control<any>;
  fields: (keyof BranchValues)[];
};

const useBranchForm = ({ control, fields }: UseBranchFormProps) => {
  if(!control || !fields.length){
    return {
      formValues : null,
      showError : null,
      errorMessage : null
    }
  }
  const watchedValues = useWatch({ control, name: fields });

  // ✅ Use `useFormState` to track live errors
  const { errors } = useFormState({ control });

  const formValues = useMemo(() => {
    return fields.reduce((acc, field, index) => {
      acc[field] = watchedValues[index];
      return acc;
    }, {} as Partial<BranchValues>);
  }, [watchedValues, fields]);

  const showError = {
    branchId: !!errors?.branchId,
    branchAcademicBatchId: !!errors?.branchAcademicBatchId,
    academicClassId: !!errors?.academicClassId,
    academicSectionId: !!errors?.academicSectionId,
  }

  const errorMessage = {
    branchId: errors?.branchId?.message,
    branchAcademicBatchId: errors?.branchAcademicBatchId?.message,
    academicClassId: errors?.academicClassId?.message,
    academicSectionId: errors?.academicSectionId?.message,
  };

  return {
    formValues,
    showError,
    errorMessage,
  };
};

export default useBranchForm;
